import { UNIFIED_EVENT } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { List } from 'immutable';
import { addCondition, getLogicGroupConditionsSize, removeKeyPath, setKeyPath } from '../../filterQueryFormat/logic/LogicGroup';
import { isOperator } from '../../filterQueryFormat/operator/Operator';
import { useContext } from 'react';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useStrategy } from '../../hooks/useStrategy';
import { useValidateCondition } from '../../hooks/useValidateCondition';
import { And } from '../../filterQueryFormat/logic/FilterLogicGroup';
import EditorUnifiedEventRefinement from './EditorUnifiedEventRefinement';
import EditorUnifiedEventRefinementResponsive from './EditorUnifiedEventRefinementResponsive';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getRefinementWithSameField = (field, refinements) => {
  const conditions = refinements && refinements.conditions ? refinements.conditions.toObject() : {};
  const [refinementKey, refinement] = Object.entries(conditions).find(([, condition]) => {
    return isOperator(condition) && condition.field && condition.field.name === field.name;
  }) || [];
  if (refinementKey && isOperator(refinement)) {
    return {
      refinementKeyPath: List.of(refinementKey),
      refinement
    };
  }
  return {
    refinementKeyPath: undefined,
    refinement: undefined
  };
};
const EditorUnifiedEventRefinements = ({
  conditionPath,
  logicGroup,
  inputUse
}) => {
  const {
    internalDraftValue,
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onChangeInternal
  } = useEditorActions();
  const {
    getRefinementFields
  } = useStrategy();
  const {
    validateCondition
  } = useValidateCondition();
  const refinementFields = getRefinementFields(UNIFIED_EVENT);
  if (!refinementFields) {
    return null;
  }
  const onRefinementsChange = newRefinements => {
    const refinements = !getLogicGroupConditionsSize(newRefinements) ? undefined : newRefinements;
    const newInternalDraftValue = setKeyPath(conditionPath, logicGroup.set('refinements', refinements), internalDraftValue);
    onChangeInternal(newInternalDraftValue);
  };
  const onRefinementChange = keyPath => {
    return (newRefinement, shouldValidate = true) => {
      if (!newRefinement) {
        onRefinementsChange(removeKeyPath(keyPath, logicGroup.refinements));
        return;
      }
      const validatedNewRefinement = shouldValidate ? validateCondition(logicGroup.filterFamily, newRefinement) : newRefinement;
      if (!keyPath) {
        onRefinementsChange(addCondition(validatedNewRefinement, logicGroup.refinements || And.of()));
      } else {
        onRefinementsChange(setKeyPath(keyPath, validatedNewRefinement, logicGroup.refinements));
      }
    };
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.values(refinementFields).map(field => {
      const {
        refinementKeyPath,
        refinement
      } = getRefinementWithSameField(field, logicGroup.refinements);
      return useOnePanel ? /*#__PURE__*/_jsx(View, {
        marginBlockStart: "300",
        as: "div",
        children: /*#__PURE__*/_jsx(EditorUnifiedEventRefinementResponsive, {
          field: field,
          refinement: refinement,
          onRefinementChange: onRefinementChange(refinementKeyPath),
          inputUse: inputUse
        })
      }, `unified-event-refinement-${field.name}`) : /*#__PURE__*/_jsx(EditorUnifiedEventRefinement, {
        field: field,
        refinement: refinement,
        onRefinementChange: onRefinementChange(refinementKeyPath),
        inputUse: inputUse
      }, `unified-event-refinement-${field.name}`);
    })
  });
};
export default EditorUnifiedEventRefinements;